import { get, post, put } from './http-calls';

export const getInspectionSheetList = async () => {
    let res = await get('InspectionSheetList', { useAuthToken: true });
    return res;
};

export const getInspectionSheetListById = async (listId) => {
    let res = await get(`InspectionSheetList/${listId}`, { useAuthToken: true });
    return res;
};

export const addInspectionSheetList = async (listName) => {
    let res = await post(
        'InspectionSheetList',
        {
            ListName: listName
        },
        { useAuthToken: true }
    );
    return res;
};

export const updateInspectionSheetList = async (listId, listName) => {
    let res = await put(
        `InspectionSheetList/${listId}`,
        {
            ListName: listName
        },
        { useAuthToken: true }
    );
    return res;
};

export const addOrUpdateInspectionSheetListOptions = async (listId, listOptions) => {
    let res = await post(`InspectionSheetList/${listId}`, listOptions, { useAuthToken: true });
    return res;
};
